import { useState } from 'react'

const useSessionToken = () => {
   const [token, setToken] = useState(JSON.parse(localStorage.getItem("env") || "{}"))
   return token.token
}

export default useSessionToken